<template>
  <div class="body" style="direction: rtl;">
      <div class="loginNew">
          <div class="login-container">
            <div style="width:100%;text-align:center;">
                <img src="https://carerp.io/wp-content/uploads/2023/07/carerp.png" style="width:200px;" />
            </div>
            <div style="width:500px;padding:20px;">
<!-- From Uiverse.io by yashasvi9199 -->
<div class="card">
  <div class="card2">
    <form class="form">
      <p id="heading">Login</p>
      <div class="field">
        <svg
          viewBox="0 0 16 16"
          fill="currentColor"
          height="16"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
          class="input-icon"
        >
          <path
            d="M13.106 7.222c0-2.967-2.249-5.032-5.482-5.032-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.43.199-1.354.328-2.29.328-2.926 0-4.813-1.88-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.416 2.769-.492 0-.772-.28-.772-.76V5.206H8.923v.834h-.11c-.266-.595-.881-.964-1.6-.964-1.4 0-2.378 1.162-2.378 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.11c.081.67.703 1.148 1.503 1.148 1.572 0 2.57-1.415 2.57-3.643zm-7.177.704c0-1.197.54-1.907 1.456-1.907.93 0 1.524.738 1.524 1.907S8.308 9.84 7.371 9.84c-.895 0-1.442-.725-1.442-1.914z"
          ></path>
        </svg>
        <input
          type="text"
          class="input-field"
          placeholder="Username"
          autocomplete="off"
        />
      </div>
      <div class="field">
        <svg
          viewBox="0 0 16 16"
          fill="currentColor"
          height="16"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
          class="input-icon"
        >
          <path
            d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"
          ></path>
        </svg>
        <input type="password" class="input-field" placeholder="Password" />
      </div>
      <div class="btn">
        <button class="button1">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Login&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </button>
        <button class="button2">Sign Up</button>
      </div>
      <button class="button3">Forgot Password</button>
    </form>
  </div>
</div>

            </div>

          </div>
          <div class="butonEria">
            <div class="button">
                <div class="titles">للشركات</div>
                <div class="buttns">
                    <div class="buttns-rows">
                        CAR ERP
                    </div>
                    <div class="buttns-rows">
                        شركات الاطارات
                    </div>
                    <div class="buttns-rows">
                        شركات الزيوت
                    </div>
                    <div class="buttns-rows">
                        شركات البناشر
                    </div>
                    <div class="buttns-rows">
                        شركات زينة السيارات
                    </div>
                    <div class="buttns-rows">
                        شركات مغاسل السيارات
                    </div>
                </div>
            </div>
            <div class="button">
                <div class="titles">نظام المؤسسات</div>
                <div class="buttns">
                    <div class="buttns-rows">
                        ورش السيارات
                    </div>
                    <div class="buttns-rows">
                        مؤسسات الاطارات
                    </div>
                    <div class="buttns-rows">
                        مؤسسات الزيوت
                    </div>
                    <div class="buttns-rows">
                        مؤسسات البناشر
                    </div>
                    <div class="buttns-rows">
                        مؤسسات زينة السيارات
                    </div>
                    <div class="buttns-rows">
                        مؤسسات مغاسل السيارات
                    </div>
                </div>
            </div>
          </div>
      </div>
    <v-row style="display:none;">
      <v-col cols="12" md="6">
        <div class="mt-10 pa-10 text-center">
            <div class="errorMesg" v-if="showerr">اسم المستخدم او كلمة المرور غير صحيحة يرجى المحاولة مره اخرى</div>
            <div class="mt-16" :style="`border-radius:10px;color:#FFF;background:rgb(0, 0, 0);margin:auto;direction: `+this.lang.dir+`;width:300px;border:1px solid #000`">
              <div class="text-start pa-3">
                <label for="input-live">{{lang.login_name}}</label>
                  <b-form-input
                    id="username"
                    v-model="username"
                    @keyup.enter="enterlogin()"
                    aria-describedby="input-live-help input-live-feedback"
                    :placeholder="lang.login_name"
                    @keyup.native.enter="doLogin()"
                    trim
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="!nameState" id="input-live-feedback">
                    {{lang.required_field}}
                  </b-form-invalid-feedback>
              </div>
              <div class="text-start pa-3 pt-0">
                <label for="input-live">{{lang.password}}</label>
                  <b-form-input
                    id="password"
                    v-model="password"
                    @keyup.enter="enterlogin()"
                    aria-describedby="input-live-help input-live-feedback"
                    :placeholder="lang.password"
                    @keyup.native.enter="doLogin()"
                    type="password"
                    trim
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="!passState" id="input-live-feedback">
                    {{lang.required_field}}
                  </b-form-invalid-feedback>
              </div>
              <div class="pa-3 pt-0" style="display:flex;flex-direction:row;justify-content:space-between;flex-wrap:wrap" v-if="branches.length > 1">
                  <div class="text-start" style="direction:rtl;width:50%"  v-for="(item , index) in branches" :key="index">
                    <button class="btn btn-success" :id="`branch${item.id}`" v-if="index == 0" @click="changeBranch(item.id)" style="font-size:1rem;border:1px solid #000;background:#84c8ff;width:100%;border-radius:0;color:#000 !mportant;font-weight:bolder">{{ item[`name_${lang.langname}`] }}</button>
                    <button class="btn btn-success" :id="`branch${item.id}`" v-else @click="changeBranch(item.id)" style="font-size:1rem;border:1px solid #000;background:#eee;color:#000;width:100%;border-radius:0;font-weight:bolder">{{ item[`name_${lang.langname}`] }}</button>
                  </div>
              </div>
              <div class="pa-3 pt-0" style="display:flex;flex-direction:row;justify-content:space-between;flex-wrap:wrap" v-if="financeYear.length > 1">
                  <div class="text-start" style="direction:rtl;width:100%">
                    <b-form-select class="selborder" @change="setFinanceYear()" v-model="fYear" :options="FinYears" />
                  </div>
              </div>

              <div class="text-start pa-3 pt-0" style="direction:rtl">
                  <button class="btn btn-success" id="arabic" @click="changeLang('ar','ar')" style="border:1px solid #000;background:#84c8ff;width:50%;border-radius:0;color:#000 !mportant;font-weight:bolder">عربي</button>
                  <button class="btn btn-success" id="english" @click="changeLang('en','en')" style="border:1px solid #000;background:#eee;color:#000;width:50%;border-radius:0;font-weight:bolder">English</button>
                  <button class="btn btn-success" id="urdu" v-if="$store.state.licenseType.activemenu=='xsmall'" @click="changeLang('en','urdu')" style="border:1px solid #000;background:#eee;color:#000;width:50%;border-radius:0;font-weight:bolder">أوردو</button>
              </div>
              <div style="margin:20px 5px;display:flex;justify-content: center;justify-items: center;">
                <b-button @click="doLogin()" type="button" class="bgbalck" style="font-size: small;width:50%;background:#84c8ff !important;color:#000 !important;font-weight:bolder"> {{loginname}}&nbsp;	&nbsp;	<i class="fas fa-sign-in-alt"></i></b-button>
<!-- From Uiverse.io by vinodjangid07 -->
<button class="Btn-Container" style="display:none;" @click="doLogin()">
  <span class="text">{{ loginname }}</span>
  <span class="icon-Container">
    <svg
      width="16"
      height="19"
      viewBox="0 0 16 19"
      fill="nones"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.61321" cy="1.61321" r="1.5" fill="black"></circle>
      <circle cx="5.73583" cy="1.61321" r="1.5" fill="black"></circle>
      <circle cx="5.73583" cy="5.5566" r="1.5" fill="black"></circle>
      <circle cx="9.85851" cy="5.5566" r="1.5" fill="black"></circle>
      <circle cx="9.85851" cy="9.5" r="1.5" fill="black"></circle>
      <circle cx="13.9811" cy="9.5" r="1.5" fill="black"></circle>
      <circle cx="5.73583" cy="13.4434" r="1.5" fill="black"></circle>
      <circle cx="9.85851" cy="13.4434" r="1.5" fill="black"></circle>
      <circle cx="1.61321" cy="17.3868" r="1.5" fill="black"></circle>
      <circle cx="5.73583" cy="17.3868" r="1.5" fill="black"></circle>
    </svg>
  </span>
</button>

              </div>

            </div>
            <div class="text-center" style="color:black">SAMCOTEC V {{$store.state.Version}}</div>
            <div class="loginSupport">{{ lang.for_more_information_or_support_firstline }}</div>
            <div class="loginSupport" style="padding:5px;border:1px solid #000;background:#FFF; ">{{ lang.for_more_information_or_support_secondline }}</div>
        </div>
        </v-col>
        <v-col style="position:relative;background:#fff;color:#000;height:100vh;margin-top:-3px;border-bottom:3px solid #84c8ff;border-top:3px solid #84c8ff;border-right:3px solid #000;border-left:3px solid #84c8ff" cols="12" md="6">
          <div class="pa-5 mt-16 text-center" style="padding-top:25% !important">
            <img :src="`../img/samcotec-logo.png`" v-if="!$store.state.licenseType.cars" style="width:130px;">
            <img :src="`../img/${$store.state.logo}`" v-else style="width:130px;">
          </div>
          <div class="pa-5 mt-16 text-center" style="padding-top:10px !important">
              <img :src="`../img/safip.png`" style="width:200px" />
              <div style="margin-top:10px;text-align: center;">
                <div style="margin-top:10px;text-align: center;"><span style="color:red">تحذيـر </span>
                  يمنع إعادة إنتاج البرنامج وملحقاته بشكل كامـل أو تقليـده دون زيـادة أو نقصان أو أجراء أي تعديل عليه
                  هذا المنتج تملكة شركة سام لتقنية المعلومات المحدوده – الرياض بموجب العلامه التجارية SAMCOTEC

                </div>
                <div style="margin-top:10px;text-align: center;">
                   باعتماد الهيئة السعودية للملكية الفكرية برقم: 1435022395 وتاريخ 05-01-1436
                </div>
              </div>
              <div class="loginSupport" style="display:none;"><br />{{ lang.for_more_information_or_support }}</div>
          </div>
        </v-col>
    </v-row>

  </div>
</template>

<script>
import axios from 'axios'

export default {

  data() {
    return {
      showStartUpMessage: false,
      showerr: false,
      username: '',
      password: '',
      loginname: 'تسجيل دخول',
      SamMessage: '',
      clientStatus: '',
      langname: "ar",
      branches: [],
      defBranch: 1,
      financeYear: [],
      fYear: (new Date()).getFullYear()
    }
  },
  computed: {
    nameState() {
      return this.username.length > 2 ? true : false
    },
    passState() {
      return this.password.length > 2 ? true : false
    },
    lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
    FinYears: function(){
      let t = [];
      for(let i=0;i<this.financeYear.length;i++){
        t.push({text: this.financeYear[i], value: this.financeYear[i]})
      }
      return t;
    }
  },
  beforeCreate() {
    //this.getStart();
  },
  created() {
    setTimeout(() => {
      this.changeLang(this.$store.state.deflang,this.$store.state.deflang);
    },1000);
    this.getStart();
    localStorage.setItem('defBranch',1);
    localStorage.setItem('financeYear',(new Date()).getFullYear());
    //document.addEventListener('keypress', this.enterlogin);
  },
  methods: {
    setFinanceYear(){
      localStorage.setItem('financeYear',this.fYear);
    },
    changeBranch(id){
      // // console.log(id);
      for(let i=0;i<this.branches.length;i++){
        if(this.branches[i].id == id){
          // document.getElementById('branch'+id).style.background = '#d7b100';
          document.getElementById('branch'+id).style.background = '#84c8ff';
          document.getElementById('branch'+id).style.color = '#000';
        }else{
          document.getElementById('branch'+this.branches[i].id).style.background = '#eeeeee';
          document.getElementById('branch'+this.branches[i].id).style.color = '#000000';
        }
      }
      this.defBranch = id;
      localStorage.setItem('defBranch',id);
    },
    changeLang(id,sub) {
      console.log([id,sub]);
      if(id != "ar" && id != "en"){
        id = "ar";
      }
      console.log(this.$store.state.LangCooki);
      this.$cookies.set(this.$store.state.LangCooki, id)
      if(id == "ar" && sub == "ar") {
        // document.getElementById('arabic').style.background = '#84c8ff';
        document.getElementById('arabic').style.background = '#84c8ff';
        document.getElementById('arabic').style.color = '#000';
        document.getElementById('english').style.background = '#eeeeee';
        document.getElementById('english').style.color = '#000000';
        document.getElementById('urdu').style.background = '#eeeeee';
        document.getElementById('urdu').style.color = '#000000';
      }else if(id == "en" && sub == "en"){
        document.getElementById('arabic').style.background = '#eeeeee';
        document.getElementById('arabic').style.color = '#000000';
        document.getElementById('english').style.background = '#84c8ff';
        document.getElementById('english').style.color = '#000';
        document.getElementById('urdu').style.background = '#eeeeee';
        document.getElementById('urdu').style.color = '#000000';
      }else if(id == "en" && sub == "urdu"){
        document.getElementById('arabic').style.background = '#eeeeee';
        document.getElementById('arabic').style.color = '#000000';
        document.getElementById('english').style.background = '#eeeeee';
        document.getElementById('english').style.color = '#000';
        document.getElementById('urdu').style.background = '#84c8ff';
        document.getElementById('urdu').style.color = '#000000';
      }
      this.langname = id;
      this.$store.state.deflang = id
      this.$cookies.set(this.$store.state.LangCooki, id)
      localStorage.setItem("subLang", sub)
      // if(id == "ar"){
      //   document.getElementById('arabic').style.background = "#84c8ff";
      //   document.getElementById('arabic').style.color = "#000";
      //   document.getElementById('english').style.background = "#eee";
      //   document.getElementById('english').style.color = "#000";
      // }else{
      //   document.getElementById('english').style.background = "#84c8ff";
      //   document.getElementById('english').style.color = "#000";
      //   document.getElementById('arabic').style.background = "#eee";
      //   document.getElementById('arabic').style.color = "#000";
      // }
      // this.$store.state.deflang = id
      // this.$cookies.set(this.$store.state.LangCooki, id)
      // if(id == 'en'){
      //   this.$parent.lang = this.$store.state.lang.en;
      //   this.lang.dir = "ltr";
      //   this.lang.ldir = "rtl";
      //   this.lang.login_name = "Username";
      //   this.lang.password = "Password";
      //   this.lang.save_login_info = "Save login info";
      //   this.loginname = "Login"
      //   this.$parent.for_more_information_or_support_firstline = " 1For support, or any inquires please contat us"
      //   this.$parent.for_more_information_or_support_secondline = "0566566160 - 0595907777 - 0565100268"
      // }else{
      //   this.$parent.lang = this.$store.state.lang.ar;
      //   this.lang.dir = "rtl";
      //   this.lang.ldir = "ltr";
      //   this.lang.login_name = "اسم الدخول";
      //   this.lang.password = "كلمة المرور";
      //   this.lang.save_login_info = "حفظ بيانات الدخول";
      //   this.loginname = "تسجيل الدخول"
      //   this.$parent.for_more_information_or_support_firstline = "للدعم الفني الاتصال"
      //   this.$parent.for_more_information_or_support_secondline = "0566566160 - 0595907777 - 0565100268"
      // }
    },
    enterlogin(){
      // e.preventDefault();
      // if (event.keyCode == 13){
        // if(this.username == '') {
        //   document.getElementById('username').focus();
        //   return false;
        // }
        // if(this.password == '' && this.username != '') {
        //   document.getElementById('password').focus();
        //   return false;
        // }
        // this.doLogin();

    },
    getStart(){
      let pp = new FormData();
      pp.append('defBranch',localStorage.getItem('defBranch'));
      pp.append('financeYear',localStorage.getItem('financeYear'));
      let type = 'getMeTodo';

      pp.append('type',type);
      axios.post(
          this.$store.state.SAMCOTEC.r_path
          ,pp
      ).then((response) => {
        // // console.log(response.data);
        this.$store.state.loginRedirect = response.data.results.redirectURl;
        localStorage.setItem('redirectURl',response.data.results.redirectURl);
        this.branches = response.data.results.branches
        this.financeYear = response.data.results.financeYear
        localStorage.setItem('_ECar_',JSON.stringify(response.data.results.data));
        this.$store.commit('setLicenseType',response.data.results.data);
      })

    },
    doLogin(){
      let pp = new FormData();
      pp.append('defBranch',localStorage.getItem('defBranch'));
      pp.append('financeYear',localStorage.getItem('financeYear'));
      let type = 'register';

      pp.append('data[username]',this.username);
      pp.append('data[password]',this.password);
      pp.append('type',type);
      pp.append('data[defBranch]',this.defBranch);
      pp.append('defBranch',this.defBranch);

      axios.post(
          this.$store.state.SAMCOTEC.r_path
          ,pp
      ).then((response) => {

          let res = response.data;
          if(res.error.number == 200){
              this.$store.state.userinfo = res.results.data;
              this.ip = "DM3-CMS-M33-103-650";
              let code = res.results.data.ID+'||'+res.results.hash+'||'+this.ip+'||'+res.results.time+'||'+this.$cookies.get(this.$store.state.LangCooki)+'||'+this.defBranch;
              this.$cookies.set(this.$store.state.COOKIEPhase,code,86400);
              this.$store.commit('setEffectivePermissions', res.results.data.effective_permissions || {});
              this.$store.state.group_id = res.results.data.group_id;
              this.$store.state.loginRedirect = res.results.data.redirectURl;
            if(res.results.data.group_id == 9){
              this.$store.state.loginRedirect = "/clientList-mobile";
              this.$router.push({path: this.$store.getters['state'].loginRedirect})
            }

            else{
              localStorage.setItem('currentMenu',1)
              this.$router.push({path: this.$store.getters['state'].loginRedirect})
              // this.$router.push({path: "/POS-RETAIL"})
            }
          }else{
            this.showerr = true;
          }
      });
    }
  },
}
</script>
<style>
.butonEria{
    margin-top:20px;
    width:100%;
    display: flex;
    flex-direction: row;
    gap:10px;
    justify-content: center;
    justify-items: center;
    flex-wrap: wrap;
}
.buttns{
    width:100%;
    padding:10px;
    display: flex;
    gap: 5px;
    flex-direction: row;
    justify-content: center;
    justify-items: center;
    flex-wrap: wrap;
}
.button{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width:49%;
}
.titles{
    text-align:center;
    background: #84c8ff;
    border:1px solid #000;
    padding:2px;
    width:100%;
    height: 25px;
}
.buttns-rows{
    width:100px;
    height: 100px;
    display: flex;
    flex-direction: column;
    text-align:center;
    justify-content: center;
    justify-items: center;
    color:#000;
    border:1px solid #000;

}
.body{
  border:3px inset #000;
  background:#84c8ff !important;
  color:#000;
  height: 100vh;
}
.bgbalck{
  background:rgb(0,0,0) !important;
  color:#FFF !important;
}
.errorMesg{
  background:rgba(0, 0, 0,0.5);
  padding:5px;
  width:50%;
  margin:auto;
  border-radius: .8rem;
}
.loginSupport{
  z-index:4000;
  /* position: absolute; */
  margin-top:10px;
  bottom: 0px;
  left: 0;
  right:0;
  padding:5px;
  text-align:center;
  font-size:1.2rem;
  /* background:#000; */
  color:#000;
}
.loginNew{
    position:fixed;
    top:20px;
    left:20px;
    right:20px;
    bottom:20px;

    display:flex;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
    align-items: center;
    margin-inline: 10%;
    border:1px solid #000;
    background:#fff;
}
.login-container{
    display: flex;
    width:100%;
    flex-direction: column;
    gap: 5px;
    justify-content: center;
    justify-items: center;
    align-items: center;
}


/* From Uiverse.io by yashasvi9199 */
.form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 2em;
  padding-right: 2em;
  padding-bottom: 0.4em;
  background-color: #171717;
  border-radius: 25px;
  transition: 0.4s ease-in-out;
}

.card {
  background-image: linear-gradient(163deg, #00ff75 0%, #3700ff 100%);
  border-radius: 22px;
  transition: all 0.3s;
  width:400px;
}

.card2 {
  border-radius: 0;
  transition: all 0.2s;
}

.card2:hover {
  transform: scale(0.98);
  border-radius: 20px;
}

.card:hover {
  box-shadow: 0px 0px 30px 1px rgba(0, 255, 117, 0.3);
}

#heading {
  text-align: center;
  margin: 2em;
  color: rgb(255, 255, 255);
  font-size: 1.2em;
}

.field {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  border-radius: 25px;
  padding: 0.6em;
  border: none;
  outline: none;
  color: white;
  background-color: #171717;
  box-shadow: inset 2px 5px 10px rgb(5, 5, 5);
}

.input-icon {
  height: 1.3em;
  width: 1.3em;
  fill: white;
}

.input-field {
  background: none;
  border: none;
  outline: none;
  width: 100%;
  color: #d3d3d3;
}

.form .btn {
  display: flex;
  justify-content: center;
  flex-direction: row;
  margin-top: 2.5em;
}

.button1 {
  padding: 0.5em;
  padding-left: 1.1em;
  padding-right: 1.1em;
  border-radius: 5px;
  margin-right: 0.5em;
  border: none;
  outline: none;
  transition: 0.4s ease-in-out;
  background-color: #252525;
  color: white;
}

.button1:hover {
  background-color: black;
  color: white;
}

.button2 {
  padding: 0.5em;
  padding-left: 2.3em;
  padding-right: 2.3em;
  border-radius: 5px;
  border: none;
  outline: none;
  transition: 0.4s ease-in-out;
  background-color: #252525;
  color: white;
}

.button2:hover {
  background-color: black;
  color: white;
}

.button3 {
  margin-bottom: 3em;
  padding: 0.5em;
  border-radius: 5px;
  border: none;
  outline: none;
  transition: 0.4s ease-in-out;
  background-color: #252525;
  color: white;
}

.button3:hover {
  background-color: red;
  color: white;
}

</style>
